import { AppApiGateway } from '@repo/api/web/AppApiGateway'
import type {
  NotificationsListRequestQuery,
  PageOfNotificationDto,
} from '@repo/api/web/models'
import { inject, injectable } from 'inversify'

@injectable()
export class NotificationsService {
  protected appConfig: ReturnType<typeof useAppConfig>

  constructor(
    @inject(AppApiGateway)
    readonly api: AppApiGateway,
  ) {
    this.appConfig = useAppConfig()
  }

  list(query: NotificationsListRequestQuery): Promise<PageOfNotificationDto> {
    return this.api.notificationsList(this.appConfig.host, query)
  }

  markAllViewed(): Promise<void> {
    return this.api.notificationsMarkAllViewed(this.appConfig.host)
  }

  markViewed(id: number): Promise<void> {
    return this.api.notificationsMarkViewed(id, this.appConfig.host)
  }
}
